import { getLocaleDate } from '../../utils';

const getColorByStatus = (completed) => {
  if (completed) {
    return '#3F8F83';
  }
  return '#9679EE';
};

const getBackgroundByStatus = (completed) => {
  if (completed) {
    return '#EBFEF7';
  }
  return '#F5F0FE';
};

const ParticipationOfferCard = (
  {
    offerId,
    title,
    pointsName = 'Points',
    pointsValue = 0,
    completed = false,
    iconUrl,
    latestUpdate,
  },
  getText,
) => {
  const statusColor = getColorByStatus(completed);
  const statusBackground = getBackgroundByStatus(completed);
  let statusText = getText('offerwall.history.offers.inProgress');
  if (completed) {
    statusText = getText('offerwall.history.offers.completed');
  }
  let activityText = getText('offerwall.history.latestActivity');
  if (completed) {
    activityText = getText('offerwall.history.activityCompleted');
  }

  const statusStyle = `
    color: ${statusColor};
    background-color: ${statusBackground};
    border-radius: 100px;
    padding: 4px 10px;
    white-space: nowrap;
  `;

  return `
  <div class="margin-sm-btm col-6 media-small-screen-full-width js-reward-offer-card" data-testid="reward-offer-card" data-id="${offerId}">
      <article class="card-v2">
        <section class="card-v2-body">
          <header class="flex flex-1 flex-justify--space-between margin-sm-btm">
            <span class="font-bold offerwall-offers-card-title">${title}</span>
            <span class="text-sm font-bold" style="${statusStyle}">
              ${statusText}
            </span>
          </header>
          <div class="flex">
            ${
              iconUrl
                ? `<img
                class="margin-xs-right offerwall-offers-card-icon"
                src="${iconUrl}"
                alt="${title}"
              />`
                : ''
            }
            <div class="flex-1" style="width: calc(100% - 104px);">
              <h1
                class="text-xxl font-bold margin-reset line-height-reset js-offer-points"
                data-offer-id="${offerId}"
              >
                ${pointsValue}
              </h1>
              <p
                class="margin-reset margin-sm-btm"
                data-testid="offer-reward-currency"
              >
                ${pointsName}
              </p>
                <span
                  class="text-grey-light"
                  style="display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                >
                <i>${(activityText || '').replace(
                  'XXXX',
                  getLocaleDate(latestUpdate),
                )}</i>
                </span>
              </p>  
            </div>
          </div>
        </section>
      </article>
    </div>
  `;
};

export default ParticipationOfferCard;
